import styled, {css} from 'styled-components'

export const StyledAccordion = styled.section`
    ${({theme}) => css`
        border: 1px solid ${theme.palette.neutral['200']};
        border-radius: 8px;
        overflow: hidden;
    `}
`

export const StyledAccordionHeader = styled.button`
    ${({theme}) => css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${theme.spacing * 2}px;
        padding: ${theme.spacing * 3}px ${theme.spacing * 4}px;
        background: ${theme.palette.neutral['50']};
        border: none;
        cursor: pointer;
        transition: ${theme.transition};

        &:hover {
            background: ${theme.palette.neutral['100']};
        }

        & > svg {
            width: 16px;
            height: 16px;
            color: ${theme.palette.neutral['600']};
            flex-shrink: 0;
        }
    `}
`

export const StyledAccordionTitleGroup = styled.span`
    ${({theme}) => css`
        display: inline-flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;

        & > svg {
            width: 16px;
            height: 16px;
            color: ${theme.palette.primary['600']};
            flex-shrink: 0;
        }

        & > strong {
            ${theme.typography.textSm};
            font-weight: 500;
            color: ${theme.palette.neutral['900']};
        }
    `}
`

export const StyledFilterBadge = styled.span<{$isActive: boolean}>`
    ${({theme, $isActive}) => css`
        padding: ${theme.spacing * 0.5}px ${theme.spacing * 2}px;
        border-radius: 999px;
        ${theme.typography.textXs};
        font-weight: 500;
        background: ${$isActive ? theme.palette.primary['100'] : theme.palette.warning['100']};
        color: ${$isActive ? theme.palette.primary['700'] : theme.palette.warning['700']};
    `}
`

export const StyledAccordionBody = styled.div`
    ${({theme}) => css`
        padding: ${theme.spacing * 4}px;
        background: ${theme.palette.neutral.white};
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 4}px;
    `}
`
